import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'
import router from './router'
import store from './store/index'

import './plugins/font-awesome.js'
import { auth } from './firebase'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
  fieldsBagName: 'vee-fields'
})

const unsubscribe = auth.onAuthStateChanged((user) => {
  if (user) {
    // User is signed in.
    const { uid, displayName, email } = user
    store.dispatch('autoLogIn', { uid, displayName, email })
  } else {
    console.log('<<<<<< NO USER!! >>>>>>')
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  unsubscribe()
})
